(() => {
  class VariantSync {
    constructor() {
      // Page has many product forms (related products, carousels - 160+ on this
      // template). The MAIN form is the only one with the preorder input.
      // Anchor to that form instead of grabbing the first one in the DOM.
      this.preOrderVariantInput = document.querySelector('.preorder-variant-id');
      this.form = this.preOrderVariantInput
        ? this.preOrderVariantInput.closest('[data-product-form]')
        : document.querySelector('[data-product-form]');
      if (!this.form) return;

      this.variantSelectors = this.form.querySelectorAll('[data-single-option-selector]');
      this.mainVariantInput = this.form.querySelector('.main-variant-id');
      this.preOrderButton = this.form.querySelector('.preorder-btn');
      this.mainAddButton = this.form.querySelector('.main-add-btn');

      const productDataEl = document.querySelector('.product-variants-json');
      const preorderDataEl = document.querySelector('.preorder-variants-json');

      try {
        this.productVariants = JSON.parse(productDataEl?.textContent || '[]');
        this.preOrderVariants = JSON.parse(preorderDataEl?.textContent || '[]');
      } catch (e) {
        console.warn('Variant data JSON invalid:', e);
        return;
      }

      this.originalVariantId = this.mainVariantInput?.value || '';

      this.init();
    }

    init() {
      if (!this.variantSelectors.length || !this.productVariants.length) return;

      this.variantSelectors.forEach((selector) => {
        selector.addEventListener('change', () => this.handleVariantChange());
      });

      if (this.mainAddButton) {
        this.mainAddButton.addEventListener('click', () => {
          this.setMainVariantId(this.originalVariantId);
        });
      }

      if (this.preOrderButton) {
        this.preOrderButton.addEventListener('click', () => {
          this.setMainVariantId(this.preOrderVariantInput.value);
        });
      }

      this.handleVariantChange(); // Initial render
    }

    getSelectedOptions() {
      // Radios for one option share a name; collecting per-selector gives
      // duplicates (8 size buttons = 8 identical values). Dedupe by option name.
      const seen = {};
      const result = [];
      Array.from(this.variantSelectors).forEach((selector) => {
        const name = selector.name;
        if (seen[name]) return;        // already captured this option
        seen[name] = true;
        if (selector.tagName === 'SELECT') {
          result.push(selector.value);
        } else {
          const checked = this.form.querySelector(`[name="${name}"]:checked`);
          result.push(checked?.value || '');
        }
      });
      return result;
    }

    findMatchingVariant(variants, options) {
      return variants.find((variant) => {
        return variant.options.every((opt, i) => opt === options[i]);
      });
    }

    handleVariantChange() {
      const selectedOptions = this.getSelectedOptions();

      const matchedMainVariant = this.findMatchingVariant(this.productVariants, selectedOptions);
      if (matchedMainVariant) {
        this.setMainVariantId(matchedMainVariant.id);
        this.originalVariantId = matchedMainVariant.id;
      }

      const matchedPreOrderVariant = this.findMatchingVariant(this.preOrderVariants, selectedOptions);
      if (matchedPreOrderVariant && matchedPreOrderVariant.available) {
        this.preOrderVariantInput.value = matchedPreOrderVariant.id;
        this.preOrderButton.style.display = 'inline-block';
        this.preOrderButton.querySelector("button").removeAttribute('disabled');
        console.log(this.preOrderButton.querySelector("button"));
      } else {
        this.preOrderButton.style.display = 'none';
        this.preOrderButton.querySelector("button").setAttribute('disabled', 'disabled');
      }
    }

    setMainVariantId(variantId) {
      if (this.mainVariantInput) {
        this.mainVariantInput.value = variantId;
      }
    }
  }

  new VariantSync();
})();
